<template>
  <button
    :class="getClass"
    :style="getStyle"
    @click="buttonClick"
    :disabled="disabled"
  >{{ buttonText }}</button>
</template>
<script>
export default {
  props: ["buttonText", "buttonStyle", "disabled"],
  computed: {
    getClass() {
      switch (this.buttonStyle) {
        case "searchButton":
          return "btn";
        case "requestListTabSelectionPartner":
          return "btn primary-btn button-class-tab mt-1 ml-0";
        case "defaulfRequestListTabSelectionPartner":
          return "btn primary-btn button-class-defaultTab mt-1 ml-0";
        default:
          return "btn btn-primary button-style";
      }
    },
    getStyle() {
      switch (this.buttonStyle) {
        case "requestListTabSelectionPartner":
          return "min-width:180px;height: 30px;";
        case "defaulfRequestListTabSelectionPartner":
          return "min-width:180px;height: 30px;";
        case "searchButton":
          return "float:right; margin-top:20px; margin-left:auto; width: 100px; height: 32px; border-radius: 3px; border: solid 1px #507cb2; background-color: #1579ab; color: #fff; font-size: 15px; font-weight: normal;";
      }
    }
  },
  methods: {
    buttonClick(event) {
      this.$emit("onButtonClick", event);
    }
  }
};
</script>
<style scoped>
.button-class-tab {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: center;
  color: white;
  border-radius: 0px;
  background-color: #1579ab;
  box-shadow: none;
}
.button-class-defaultTab {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: center;
  border-radius: 0px;
  border: solid 1px #1579ab;
  background-color: #f8f8f8;
  color: #1579ab;
  box-shadow: none;
}
</style>